import { Component, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { distributionAssetsIncomeOptions } from '../../services/ref';

@Component({
    selector: 'distribution-assets-income',
    templateUrl: './distribution-assets-income.component.html',
    styleUrls: ['./distribution-assets-income.component.scss'],
    standalone: false
})
export class DistributionAssetsIncomeComponent implements OnInit {
  distributionAssetsForm: UntypedFormArray;

  options = distributionAssetsIncomeOptions;

  @Input() derrors: any = undefined;
  countries: any[];

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.distributionAssetsForm = this.controlContainer
      .control as UntypedFormArray;
  }

  addFields() {
    this.distributionAssetsForm.push(
      new UntypedFormGroup({
        fundOrigin: new UntypedFormControl('FINANCIAL_ASSETS', [
          Validators.required,
        ]),
        distribution: new UntypedFormControl(100, [Validators.required]),
      }),
    );

    this.distributionAssetsForm.markAsUntouched();
  }

  deleteFields(index) {
    this.distributionAssetsForm.removeAt(index);
  }

  ngOnChanges() {
    if (this.distributionAssetsForm)
      this.distributionAssetsForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
